import { INotificationChannelDTO } from "@/interface"

export class NotificationChannel {
    public id: number;
    public notification: string;
    public channel: string;
    public isActive: boolean;

    constructor(base?: Partial<NotificationChannel>){
        if(base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: INotificationChannelDTO) {
        if (!dto) {
            return null;
        }
        return new NotificationChannel({
            id: dto.id,
            notification: dto.notification,
            channel: dto.type,
            isActive: dto.isActive
        });
    }
}